<template>  
    <!-- <v-card> -->
        <v-label class="form-label text-start w-100">
            {{ modelValue.title }}
            <span v-if="modelValue.mandatory" class="text-danger">*</span>
        </v-label>
        <v-checkbox
            v-for="(option, idx) in modelValue.options"
            :id="`${modelValue.id}-${idx}`" 
            :key="idx"
            :label="option.title"
            :value="idx"
            hide-details
            density="comfortable"    
            v-model="modelValue.value"    
        />
    <!-- </v-card> -->
</template>

<script>
export default {
    name: 'CheckboxesComponent',

    props: ['modelValue',], //modelValue - it the name of the prop that will be used for v-model binding (from parent component)
    emits: ['update:modelValue'],

    data() {
        return {
        };
    },

    created() {        
    },


    methods: {
        handleChange(event, idx) {
            console.log("Current model", this.modelValue);
            let newModelValue = {
                ...this.modelValue,
                error: '', // Reset any previous error
            };
            if(event.target.checked){ // Add idx
                newModelValue.value.push(idx);
            }
            else{ // Remove idx
                let index = newModelValue.value.indexOf(idx);
                if (index > -1) {
                    newModelValue.value.splice(index, 1);
                }                
            }
            console.log("New model", newModelValue);


            this.$emit('update:modelValue', newModelValue);
        },
    }

}
</script>

<style scoped></style>